module.exports = __webpack_public_path__ + "static/media/71buNyy1tIL._AC_UX679_.5bd7e7f6.jpg";